import {
  getAppName,
  getAppGitCommitHash,
  getAppPackageJsonVersion,
} from "../services/env";

export const logAppVersion = (appEnv: typeof process.env): void => {
  const appName = getAppName(appEnv);
  const appGitCommitHash = getAppGitCommitHash(appEnv);

  // TODO: This should be updated to be `string`
  // instead of `string | undefined`, once all apps are on current tooling.
  // Then, this also should not require this try/catch statement.
  let appPackageJsonVersion: string | undefined;
  try {
    appPackageJsonVersion = getAppPackageJsonVersion(appEnv);
  } catch (error) {
    // do nothing. handle below.
  }

  if (appPackageJsonVersion) {
    console.log(
      `Running "${appName}" at commit hash "${appGitCommitHash}" and version "${appPackageJsonVersion}".`,
    );
  } else {
    console.log(`Running "${appName}" at commit hash "${appGitCommitHash}".`);
  }
};

export const setAppVersionForAppMonitoring = (
  appEnv: typeof process.env,
): void => {
  const { DD_RUM } = window as any;

  let appName: string | undefined;
  let appGitCommitHash: string | undefined;
  let appPackageJsonVersion: string | undefined;

  try {
    appName = getAppName(appEnv);
  } catch (error) {
    // do nothing. handle on next line.
  }
  if (!appName) {
    console.warn(
      "[@fabric/core][setAppVersionForAppMonitoring] Skipping. Unable to determine appName",
    );
    return;
  }

  try {
    appGitCommitHash = getAppGitCommitHash(appEnv);
  } catch (error) {
    // do nothing. handle on next line.
  }
  if (!appGitCommitHash) {
    console.warn(
      `[@fabric/core][setAppVersionForAppMonitoring] Skipping. Unable to determine appGitCommitHash for "${appName}"`,
    );
    return;
  }

  try {
    appPackageJsonVersion = getAppPackageJsonVersion(appEnv);
  } catch (error) {
    // do nothing. handle on next line.
  }
  if (!appGitCommitHash) {
    console.warn(
      `[@fabric/core][setAppVersionForAppMonitoring] Skipping. Unable to determine appPackageJsonVersion for "${appName}"`,
    );
    return;
  }

  if (DD_RUM?.onReady && DD_RUM?.addRumGlobalContext) {
    DD_RUM.onReady(() => {
      if (appName && appGitCommitHash) {
        console.debug(
          "[@fabric/core][setAppVersionForAppMonitoring] Calling DD_RUM.addRumGlobalContext for version and fabricAppName",
          appName,
          appGitCommitHash,
          appPackageJsonVersion,
          DD_RUM,
        );
        DD_RUM.addRumGlobalContext(`${appName}-hash`, appGitCommitHash);
        DD_RUM.addRumGlobalContext(`${appName}-version`, appPackageJsonVersion);
        DD_RUM.addRumGlobalContext("fabricAppName", appName);
      }
    });
  }
};
